module.exports = __webpack_public_path__ + "static/media/pax.7d95365f.svg";